import React from 'react';
import type { FunctionComponent } from 'react';

interface SpecialCaseStatusProps {
	setBy: string;
}

export const SpecialCaseStatus: FunctionComponent<SpecialCaseStatusProps> = ({ setBy }) => {
	return (
		<div className="account-status-tooltip">
			<p className="account-status-content-row account-status-content-row--bold">Set by:</p>
			<p className="account-status-content-row">{setBy}</p>
		</div>
	);
};
